import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaVideoCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | MetaVideoCtaTextVariables;
}

export interface MetaVideoCtaTextVariables {
  Text: string;
}

export class MetaVideoCtaTextInitVariables implements MetaVideoCtaTextVariables {
  Text = '';
}

export class MetaVideoCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaVideoCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}